// Smooth accordion animation for patine-faq <details> items
(() => {
  const items = document.querySelectorAll('.patine-faq__item');
  if (!items.length) return;

  const animate = (el, fromH, toH, onDone) => {
    el.style.height = `${fromH}px`;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.height = `${toH}px`;
        el.addEventListener('transitionend', function handler(e) {
          if (e.propertyName !== 'height') return;
          el.removeEventListener('transitionend', handler);
          onDone?.();
        });
      });
    });
  };

  items.forEach((details) => {
    const summary = details.querySelector('.patine-faq__question');
    const answer = details.querySelector('.patine-faq__answer');

    // Set initial state
    if (!details.open) {
      answer.style.height = '0';
    }

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (details.open) {
        const h = answer.scrollHeight;
        animate(answer, h, 0, () => {
          details.removeAttribute('open');
          answer.style.height = '0';
        });
      } else {
        details.setAttribute('open', '');
        const h = answer.scrollHeight;
        animate(answer, 0, h, () => {
          answer.style.height = 'auto';
        });
      }
    });
  });
})();
